import PropTypes from "prop-types";

function RadioCard({ id, image, label, value, checked, onChange }) {
  return (
    <div className="form-input form-input-radio-custom">
      <input
        required="required"
        id={id}
        type="radio"
        value={value}
        checked={checked}
        onChange={onChange}
      />

      <div className="card">
        <label htmlFor={id}>
          {image && <img src={image} width="56" height="56" alt="" />}
          <span dangerouslySetInnerHTML={{ __html: label }} />
        </label>
      </div>
    </div>
  );
}

RadioCard.propTypes = {
  id: PropTypes.string,
  image: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

export default RadioCard;
